export interface EventModel {
    name: string;
    type: EventType;
    data: any;
}

export enum EventType {
    MODAL = 'modal',
    DATATABLE = 'datatable'
}

export enum EventSubscriptionType {
    TYPE = 'type',
    NAME = 'name'
}

